import { Box, Button, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export const ProjectAddElementButton = ({
  label,
  onClick,
  size,
  sizePx,
  sx,
  addLabel,
  noBlur,
}) => {
  return (
    <Tooltip title={label}>
      <Box className={' flex rounded-lg '}>
        <Button
          onClick={onClick}
          className=" opacity-60 w-full flex "
          variant="contained"
          color="secondary"
          sx={sx}
          disableElevation
        >
          <AddIcon
            className="opacity-80"
            sx={{
              fontSize: sizePx ? sizePx : size === 'small' ? '30px' : '60px',
              marginRight: addLabel ? '10px' : '0px',
            }}
          />
          {addLabel}
        </Button>
      </Box>
    </Tooltip>
  );
};
